module.exports = __webpack_public_path__ + "img/Unidad7-5.e27f3648.png";